'use client';

export default function MessagesError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-base-200">
      <div className="bg-base-100 rounded-2xl shadow-lg p-6 max-w-md w-full text-center space-y-4">
        <h2 className="text-xl font-bold text-error">Messages Error</h2>
        <div className="text-left bg-base-200 rounded-lg p-3 text-xs overflow-auto max-h-48">
          <p className="font-semibold">{error.name}: {error.message}</p>
          {error.stack && (
            <pre className="mt-2 text-base-content/50 whitespace-pre-wrap break-words">
              {error.stack.split('\n').slice(0, 8).join('\n')}
            </pre>
          )}
        </div>
        <div className="flex gap-2 justify-center">
          <button className="btn btn-primary btn-sm" onClick={reset}>Try again</button>
          <a href="/messages" className="btn btn-ghost btn-sm">Back to Messages</a>
        </div>
      </div>
    </div>
  );
}
